import CTL_SVG from "@/compo/CTL_SVG";
import { useRef } from "react";
import { useMatches, useNavigate, useParams } from "react-router";

interface Prop_TabBTN{
  label:string;
  focused?:boolean;
  onClick?:()=>void
}
function TabBTN( prop:Prop_TabBTN ){
  return <>
    <div className={`
    ${prop.focused?'bg-white':'!bg-black/10'}
      select-none
    bg-white rounded-t-lg cursor-pointer
      px-1 py-1 
      min-w-[80px] h-[30px]
      flex items-center justify-center
    `} onClick={()=>prop.onClick&&prop.onClick()}>
      <div className="text-[.9rem] font-bold">{prop.label}</div>
    </div>  
  </>
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface Prop_Category{
  itemList:Array<{
    label:string,
    to:string,
  }>;
}

// export default function Category( {children}:any ) {
export default function Category( prop: Prop_Category ) {
  // const [ selectTabIDX, set_selectTabIDX] = useState(0);
  const param = useParams();  
  //console.log('Category param', param);
  const categoryContainer = useRef<HTMLDivElement>(null);
  const navi = useNavigate();
  const matches = useMatches();
  const handle = matches[matches.length - 1]?.handle as {label?: string} | undefined;
  
  const selectTabIDX = prop.itemList.findIndex( (v)=>v.label==handle?.label );
  
  function _selectPrev(){
    // const bound = categoryContainer.current!.getBoundingClientRect();
    categoryContainer.current!.scrollLeft = 0;
    //console.log( bound.left );
    // console.log( categoryContainer.current!.scrollLeft );
    if( selectTabIDX>0) navi( prop.itemList[selectTabIDX-1].to );
  }
  function _selectNext(){
    if( selectTabIDX<prop.itemList.length-1) navi( prop.itemList[selectTabIDX+1].to );
  }

  function _selectTab( idx:number ){
    console.log( idx );
    if( idx==3||idx==4 ){
      navi( `${prop.itemList[idx].to}${param.type_idx!=undefined?`/${param.type_idx}`:''}` );
    }else{
      navi( prop.itemList[idx].to );
    }
  }

  return<>

  <div className="bg-linear-[#FFF,#DDD]">
    <div className="h-[30px]"></div>  
    
    {/* 카테고리 표시 */}
    <div className="
      px-[10px]
      flex gap-1 items-end
    ">
      <div className="self-center border border-zinc-400 rounded bg-white" 
        onClick={()=>_selectPrev()}
      >
        <CTL_SVG  className="w-5" d="M14,7L9,12L14,17V7Z" />
      </div>

      <div ref={categoryContainer} className="flex-1 
        flex gap-1 items-end 
        overflow-x-auto
      ">
        {prop.itemList.map( (v,idx)=>
          <div key={idx} 
          // ref={
          //   (_node)=>{
          //     //console.log(node?.getBoundingClientRect().left)
          //   }
          // }
          >
          <TabBTN 
            key={idx} 
            focused={ idx==selectTabIDX }
            label={v.label}
            onClick={()=>_selectTab(idx)}
          />
          </div>
        )}
      </div>
      <div className="self-center border border-zinc-400 rounded bg-white"
        onClick={()=>_selectNext()}
      >
        <CTL_SVG className="w-5" d="M10,17L15,12L10,7V17Z" />
      </div>
      
    </div>

    <div className="bg-white rounded-t-[10px] h-[10px]"></div>
    
  </div>
  {/* <div className="bg-white">
    {prop.itemList[selectTabIDX].compo}
  </div> */}
  </>;
}
